import { createSlice } from "@reduxjs/toolkit"

export const customerOrderSlice = createSlice({
    name: 'customerOrderSlice',
    initialState: { data: '' },
    reducers: {
        setRowData: (state, action) => {
            state.data = action.payload
        },
        initRowData: (state, action) => {
            state.data = ''
        }
    }
})

export const { setRowData, initRowData } = customerOrderSlice.actions

export default customerOrderSlice.reducer